import React from 'react';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { getUniqueIndex } from 'components/transactionEditor/RequestMatchersList';
import BzmIcon from '../icons/BzmIcon';
import PairSet from './PairSet';

export interface PairSetItem {
  id: string;
  name: string | null;
  value: string | null;
  [key: string]: string | boolean | null;
}

interface PairSetListProps {
  id: string;
  pairList: PairSetItem[] | null;
  pairTitle: string;
  emptyListMessage: string;
  nonEmptyListMessage: string;
  onListChange: (list: PairSetItem[]) => void;
  isReadOnly?: boolean;
}

const PairSetList = (props: PairSetListProps) => {
  const { t } = useTranslation('transactions');
  const handleAddNew = () => {
    const emptyItem = {
      id: `${props.id}-${getUniqueIndex(props.pairList)}`,
    } as PairSetItem;
    const list = props.pairList ? props.pairList.concat(emptyItem) : [emptyItem];
    props.onListChange(list);
  };

  const handleDelete = (id: string) => {
    if (props.pairList) {
      const list = props.pairList.filter((item: PairSetItem) => item.id !== id);
      props.onListChange(list);
    }
  };

  const handleChange = (name: string, value: string, id: string) => {
    if (props.pairList) {
      const list = [...props.pairList];
      const index: number = list.findIndex(item => item.id === id);
      if (index === -1) {
        console.log(`Cannot update value! Cannot find index of ${id} in the list.`);
      } else {
        list[index][name] = value;
        props.onListChange(list);
      }
    }
  };

  if (props.pairList && props.pairList.length > 0) {
    const length = props.pairList.length;
    return (
      <div id={'qa-' + props.id}>
        <p>{props.nonEmptyListMessage}</p>
        {props.pairList.map((item: PairSetItem, index: number) => (
          <PairSet
            onChange={handleChange}
            onAdd={handleAddNew}
            onDelete={() => handleDelete(item.id)}
            displayAdd={index === length - 1}
            key={item.id}
            id={item.id}
            pairValues={item}
            pairTitle={props.pairTitle}
            isReadOnly={props.isReadOnly}
          />
        ))}
      </div>
    );
  }

  return (
    <div id={props.id}>
      <p>{props.emptyListMessage}</p>
      <Button
        disabled={props.isReadOnly}
        id={'qa-btn-add-first' + props.id}
        onClick={() => handleAddNew()}
        className="btn-circular"
        title={t('transactions:processingActions.modal.addNewPair', { name: props.pairTitle })}
      >
        <BzmIcon variant={'icon-bzm-add'} />
      </Button>
    </div>
  );
};

export default PairSetList;
